import axios from 'axios'

const state = {
  imageState: null,
  docState: null,
}

const getters = {
  getImageState (state) {
    return state.imageState
  },
  getDocState (state) {
    return state.docState
  },
}

const mutations = {
  setImageState (state, payload) {
    state.imageState = payload
  },
  setDocState (state, payload) {
    state.docState = payload
  },
}

const actions = {
  uploadImage ({ commit, rootGetters }, data) {
    return axios
      .post(rootGetters['api/uploadImage'], data)
      .then((res) => {
        if (res.status === 200) {
          commit('setImageState', res)

          return res
        }
      })
      .catch((err) => err)
  },
  uploadDoc ({ commit, rootGetters }, data) {
    return axios
      .post(rootGetters['api/uploadDoc'], data)
      .then((res) => {
        if (res.status === 200) {
          commit('setDocState', res)

          return res
        }
      })
      .catch((err) => err)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
